import React, {useContext, useEffect, useState} from 'react'

import {makeStyles} from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'
import Typography from '@material-ui/core/Typography'
import IconButton from '@material-ui/core/IconButton'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import InputLabel from '@material-ui/core/InputLabel'
import Tooltip from '@material-ui/core/Tooltip'

import HistoryIcon from '@material-ui/icons/History'
import SaveIcon from '@material-ui/icons/Save'

import _firebaseContext from '../../../contexts/firebaseContext'
import _appContext from '../../../contexts/appContext'

import HistoryDialog from '../HistoryDialog'
import TracksPanel from "../TracksPanel";

export default function PlanetsInfo({planet}) {
    const [performingAction, setPerformingAction] = useState(true)
    const [name, setName] = useState(planet.data.name || '')
    const [planetType, setPlanetType] = useState(
        planet.data.planetType || 'regular'
    )
    const [errors, setErrors] = useState(false)
    const [changed, setChanged] = useState(false)
    const [disabled, setDisabled] = useState(planet.data.disabled || false)
    const [changedData, setChangedData] = useState({})
    const [languagesList, setLanguagesList] = useState([]);
    const [locales, setLocales] = useState([]);
    const [currentLocaleId, setCurrentLocaleId] = useState('');

    const [historyDialog, setHistoryDialog] = useState(false)

    // const [errors, setErrors] = useState({
    //     name: false
    // });

    const firebaseContext = useContext(_firebaseContext)
    const appContext = useContext(_appContext)
    const classes = useStyles()

    const getLanguagesList = () => firebaseContext.getLanguages().catch((e) => console.log('getLanguagesList: ', e));
    useEffect(() => {
        (async () => {
            const langList = await getLanguagesList();
            langList.sort(a => {
                const langId = a.id.toLowerCase();
                return (langId !== 'ru') ? 1 : -1;
            });
            setCurrentLocaleId(langList[0].id);
            setLanguagesList(langList);
            setLocales(langList.map(language => language.id));
        })();
    }, []);

    const openHistoryDialog = () => {
        setHistoryDialog(true)
    }
    const handleCloseHistoryDialog = () => {
        setHistoryDialog(false)
    }

    const handleNameChange = (event) => {
        setChanged(true)
        const newName = event.target.value
        setChangedData({
            ...changedData,
            name: newName,
        })
        setName(newName)
        setErrors(false)
    }
    const handlePlanetTypeChange = (event) => {
        setChanged(true)
        const newPlanetType = event.target.value
        setChangedData({
            ...changedData,
            planetType: newPlanetType,
        })
        setErrors(false)
        setPlanetType(newPlanetType)
    }
    const handleDisabledChange = (event) => {
        setChanged(true)
        const newPlanetStatus = event.target.value
        setChangedData({
            ...changedData,
            disabled: newPlanetStatus,
        })
        setErrors(false)
        setDisabled(newPlanetStatus)
    }

    const handleSave = async (event) => {
        if (Object.keys(changedData).length === 0) return

        const result = await firebaseContext.updatePlanet(
            planet.id,
            changedData
        )

        if (result.error) {
            setErrors(true)
        }
        setChangedData({})
        setChanged(false)
        appContext.snackbar.showSnackbarMsg(result.message)
    }

    return (
        <div className={classes.tabContentWrapper}>
            {planet === undefined ? (
                <Typography variant="h5">Нет данных по планете</Typography>
            ) : (
                <>
                    <TextField
                        autoFocus
                        // disabled={!performingAction}
                        disabled={true}
                        // error={!!(errors && errors.name)}
                        error={errors}
                        label="Наименование планеты"
                        required
                        type="text"
                        value={name}
                        className={classes.textfield}

                        onChange={handleNameChange}
                    />
                    <InputLabel shrink id="planet-type">
                        Тип планеты
                    </InputLabel>
                    <Select
                        value={planetType}
                        onChange={handlePlanetTypeChange}
                        className={classes.textfield}
                        labelId="planet-type"
                    >
                        <MenuItem value="regular">Основной</MenuItem>
                        <MenuItem value="sun">Звезда</MenuItem>
                    </Select>
                    <img src={planet.data.imageUrl}/>
                    {/* <InputLabel hidden shrink id="planet-status">
                        Статус планеты
                    </InputLabel>
                    <Select
                        hidden
                        value={disabled}
                        onChange={handleDisabledChange}
                        className={classes.textfield}
                        labelId="planet-status"
                    >
                        <MenuItem value={false}>Включена</MenuItem>
                        <MenuItem value={true}>Отключена</MenuItem>
                    </Select> */}
                    <div className={classes.iconsWrapper}>
                        <IconButton
                            edge="end"
                            onClick={handleSave}
                            disabled={!changed}
                        >
                            <SaveIcon/>
                        </IconButton>
                        <Tooltip title="История редактирования">
                            <IconButton onClick={openHistoryDialog}>
                                <HistoryIcon
                                    className={`${classes.icon} ${classes.grayIcon}`}
                                />
                            </IconButton>
                        </Tooltip>
                    </div>
                    <TracksPanel
                        planetId={planet.id}
                        languagesList={languagesList}
                        localeId={currentLocaleId}
                        setLocaleId={setCurrentLocaleId}
                    />
                </>
            )}
            {historyDialog && (
                <HistoryDialog
                    open={historyDialog}
                    onClose={handleCloseHistoryDialog}
                    planet={planet}
                    locales={locales}
                />
            )}
        </div>
    )
}

const useStyles = makeStyles((theme) => ({
    tabsWrapper: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
        display: 'flex'
    },
    textfield: {
        marginBottom: '15px',
        width: '200px',
    },
    tabContentWrapper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        paddingLeft: '15px',
        paddingRight: '15px',
    },
    iconsWrapper: {
        display: 'flex',
        alignItems: 'center',
    },
}))
